import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import GeneralHelper from '../../modules/General.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Discount from './form/Discount.js';
import Notification from '../../components/Notification.js';

class Discounts extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading:false,
			isError:false,
			discount:false,
			current:false,
		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.refresh = this.refresh.bind(this);
	}

	handleSubmit(values) {
		Notification.info('Saving...');

		let method = 'post';
		let url = '/discounts';

		if(this.props.router.params.discount_id) {
			method = 'put';
			url += '/'+this.props.router.params.discount_id;
		}

		values.auto_update = ( values.auto_update === true ? 1:0);
        values.clone = ( values.clone === true ? 1:0);

		axios[method](url,values)
		.then((response) => {
			Notification.success('Discount saved');
			this.props.router.push(GeneralHelper.Link('/discounts'));
		})
		.catch((error) => {
			Notification.error(error.message);
		});

		
	}

	getCurrent() {
		let current = 'new';
		if(this.props.router.params.discount_id) {
			current = this.props.router.params.discount_id;
		}

		return current;
	}

	componentWillMount() {
		
		this.setState({'current':this.getCurrent()});
		this.refresh();
	}

	componentDidUpdate(props,state) {
		if(this.state.current != this.getCurrent()) {
			this.setState({'current':this.getCurrent()});
			this.refresh();
		}
	}

	refresh() {
		if(this.props.router.params.discount_id) {
			this.setState({isLoading:true});

			axios.get('/discounts/'+this.props.router.params.discount_id)
			.then((response) => {
				response.data.auto_update = (response.data.auto_update == 1 ? true:false);
                response.data.clone = (response.data.clone == 1 ? true:false);
				this.setState({'isLoading':false,'isError':false,discount:response.data});
			})
			.catch((error) => {
				this.setState({isError:error.message});
			});
		}
	}

	render() {

		if(this.state.isLoading) {
			return <Loading error={this.state.isError} />
		}

		if(!GeneralHelper.appHasType('ecommerce')) {
			return (
				<div className="page-content">
					<Helmet title="Discounts | Crall.io" />
					<NoResult
						header="No ecommerce addon installed"
						body="Before you can use discounts you must connect Crall to your shop. Do this by installing an app."
						link="/apps"
						button="Install app"
					/>

				</div>
				)
		}

		return (

			<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-tag"></i> Discounts</span>
				</div>
                <div className="page-content">
                    <Helmet title="Discounts | Crall.io" />
				<OptionColumn title="Settings" description="Define your discount">
					<Discount errorMessage={this.state.error} initialValues={this.state.discount ? this.state.discount:{clone:false,auto_update:false,expire: 1,type:'percent'}} isWaiting={this.state.isWaiting} onSubmit={this.handleSubmit} />
				</OptionColumn>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Discounts = connect(mapStateToProps,mapDispatchToProps)(Discounts);
export default Discounts;


// WEBPACK FOOTER //
// ./containers/discounts/DiscountNew.js